import { render, staticRenderFns } from "./videoClass.vue?vue&type=template&id=2fedffdc&scoped=true&"
import script from "./videoClass.vue?vue&type=script&lang=js&"
export * from "./videoClass.vue?vue&type=script&lang=js&"
import style0 from "./videoClass.vue?vue&type=style&index=0&id=2fedffdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fedffdc",
  null
  
)

export default component.exports